module.exports = __webpack_public_path__ + "img/newRetail-logistics-img1.d4c59e43.png";